import enLocale from 'element-ui/lib/locale/lang/en'
export default {
  "lang": "English",//中文
  // 菜单
  "menu": {
    "media": "Media",//媒体
    "data": "Data",//数据
    "docking": "Integration",//对接
    "Account": "Account",//账户
    "reconciliation": "Reconciliation",//对账
    "operator": "Current operator account:",//当前操作账号
  },
  "title": {
    "appManage": "Application Management", // 应用管理
    "appList": "Application List",//应用列表
    "adsenseManage": "Ad Slot Management",//广告位管理
    "adsenseList": "Ad Slot List",//广告位列表
    "blockManage": "Block Management", // 屏蔽管理
    "companyInfo": "Company Info",// 企业信息
    "paymentInfo": "Payment",// 结算
  },
  // 通用字段
  "common": {
    "all": "All",//全部
    "customColumn": "Custom Column",//自定义列
    "OS":"OS",//操作系统
    "app": "Application",//应用
    "adZone": "Ad Slot",//广告位
    "co_mode": "Co-op Mode",//合作模式
    "country": "Country",//国家
    "subDim": "Dimension",//细分维度
    "addApp": "Add Application",//添加应用
    "lookApp": "View Application",//查看应用
    "editApp": "Edit Application",//编辑应用
    "searchContent": "Search content",//搜索内容
    "appPackage": "App Name / Package Name",//应用名称/包名
    "searchID": "Search ID",//搜索ID
    "searchRule": "Search rule name",//搜索规则名
    "APPplatform": "Platform",//应用平台
    "selectAppPlat": "Select Platform",//选择应用平台
    "enterContent": "Enter content",//请输入内容
    "selectTemplate": "Select Template",//请选择模板名称
    "selectApp": "Select Application",//请选择所属应用
    "selectMode": "Select Cooperation Model",//请选择合作模式
    "selectFlowType": "Select Ad Type",//请选择广告类型
    "selectArea": "Select Region",//请选择合作地区
    "select": "Please Select",//请选择
    "enter": "Please enter",// 请填写
    "search": "Search",//查询
    "addAdsense": "Add Ad Slot",//添加广告位
    "addAdsenseBatch": "Batch Add Ad Slots",//批量添加广告位
    "lookAdsense": "View Ad Slot",//查看广告位
    "editAdsense": "Edit Ad Slot",//编辑广告位
    "yuan": "RMB",//元
    "meiyuan": "Dollar",//美元
    "featureConfig": "Feature Configuration",//能力配置
    "informationMothod": "Rendering Method",//信息渲染方式
    "miniProgram": "Mini Program",//可投小程序
    "quickApp": "Quick App",//可投快应用
    "appWakeup": "App Wakeup",//可投应用唤起
    "APKDownload": "APK Download",//可投下载apk
    "engagementMaterial": "Engagement Material",//可投诱导素材
    "appstoreUrl": "appstoreUrl", //appstoreUrl
    "website": "Website", //website
    "appstoreUrl_ph": "Please enter Google Play or Apple App Store URL",
    "website_ph": "Enter official website URL e.g. https://bluex.com",
    "paid": "Paid",
    "free": "Free",
    "enterRuleName": "Enter rule name",//请输入搜索规则
    "addRule": "Add Rule",//添加规则
  },
  // 复制
  "copy": {
    "copy" : "Copy",
    "copySuccess": "Copied to clipboard successfully",
    "copyError": "Copy failed",
    "copyTips": "Please create an APP first and try again"
  },
  // 表格字段
  "table": {
    "appId": "App ID", //应用id
    "appName": "App Name", //应用名称
    "appPackageName": "Package Name", //应用包名
    "appPlat": "Platform", //应用平台
    "appCate": "Category", //应用类目
    "accessMode": "Access Method", //接入方式
    "appDaily": "DAU", //应用日活
    "appType": "App Type", //应用类型
    "appKeyword": "Keywords", //应用关键词
    "wxAppid": "WeChat AppID", //微信appid
    "status": "Status", //状态
    "operation": "Actions", //操作
    "adsenseId": "Ad Slot ID",//广告位ID
    "adsenseName": "Ad Slot Name",//广告位名称
    "application": 'Application',//所属应用
    "templateName": 'Template',//模板名称
    "coMode": 'Cooperation Model',//合作模式
    "pdPrice": 'Flat-CPM',//Flat-CPM
    "zhpdPrice": 'Fixed-CPM',
    "coArea": 'Region',//合作地区
    "area": 'Region',//地区
    "operator": "Operator", //操作人
    "operateTime": "Operated at", //操作时间
  },
  // 操作
  "operation": {
    "edit": "Edit", //编辑
    "detail": "Details", //详情
    "adsense": "Ad Slot", //广告位
    "delete": "Delete", //删除
  },
  // 状态
  "status": {
    "approved": "Approved",//审核通过
    "checkPending": "Pending",//待审核
    "rejected": "Rejected",//审核驳回
    "open": "Active", //已开启
    "closed": "Inactive", //已关闭
  },
  // 校验
  "required": {
    "name": "Name required", //请输入名称
    "packageName": "Package name required", //包名不能为空
    "os": "Platform required", //请选择应用平台
    "cate": "Category required", //请选择应用类目
    "dau": "DAU required", //应用日活不能为空
    "desc": "Keywords required", //应用关键词不能为空
    "number": "Numeric value required", //请输入数值类型
    "app": "Application required", //请选择所属应用
    "adName": "Ad slot name required", //请输入广告位名称
    "template": "Template required", //请选择模板
    "templateSize": "Template size required", //请选择模板尺寸
    "pdPrice": "Flat-CPM required", //请填写Flat-CPM
    "zhpdPrice": "Fixed-CPM required", //请填写Flat-CPM
    "pdPriceLimit": "0-100 with 2 decimals", //pd校验
    "style": "Style required", //请选择样式
    "config": "Configuration required", //请选择配置
    "callbackUrl": "Callback URL required", //请填写回调URL
    "secretKey": "Secret key required", //请填写密钥
    "pdPriceNumber": "The value of flat-cpm must be a number.",// Flat-CPM的值必须是数字
    "pdPriceRange": "Flat-CPM values must be between 0-999.99", // Flat-CPM的取值必须在 0-999.99 之间
    "pdPriceFloat": "Flat-CPM retains up to 2 decimal places", // Flat-CPM最多保留 2 位小数
  },
  // 日期选择器
  "dateRangePicker": {
    "placeholder": "Select date range",//选择时间范围
    "to": "to",//至
    "today": "Today",//今天
    "yesterday": "Yesterday",//昨天
    "last7Days": "Last 7 days",//近7天
    "last30Days": "Last 30 days",//近30天
    "thisMonth": "This month",//本月
    "custom": "Custom",//自定义
    "compare": "Compare",//对比
    "curPeriod": "Current",//本期
    "cycPeriod": "Compared",//对比期
    "prevPeriod": "Previous period",//上一时间段
    "apply": "Apply",//应用
    "compareSuffixPattern": " (vs %s ~ %e)",//（对比 起 ~ 止）
    "tipSelectEnd": "Please pick the end date",//请选择结束日期
    "tipCompare": "Click a date to move the comparison range (same length as the main range)",//点击日期移动对比区间
    "weekdays": "Su,Mo,Tu,We,Th,Fr,Sa",//星期
    "monthNames": "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",//月份
    "monthLabelPattern": "%m %y"//Sep 2026
  },
  "multiSelect": {
    "all": "All",//全部
    "search": "Search",//搜索
    "selectAll": "Select all",//全选
    "selectedCountPattern": "%n selected",//已选择 N 项
    "triggerCountPattern": "%n selected",//触发器上的已选 N 项
    "clearAll": "Clear all",//全部清除
    "noneSelected": "Nothing selected",//未选择任何项
    "noMatch": "No matching items",//无匹配项
    "apply": "Apply"//应用
  },
  // 海外数据页独有的文案（statInfo 段与国内页共用，不要往里加）
  "abroadStat": {
    "bidRate": "Bid rate",//出价率
    "addMetric": "Add metric",//添加指标
    "addChart": "Add chart",//添加图表
    "dimSection": "Dimensions",//汇总报表右侧面板：维度
    "metricSection": "Metrics",//汇总报表右侧面板：指标
    "dimDate": "Date",//汇总报表的日期维度
    "dimHour": "Hour",//单日查询时日期维度显示为小时
    "metricAtLeastOne": "Keep at least one metric",//指标不可全部取消
    "dateSpanLimit": "The date range can span at most three months, please reselect",//查询时的时间跨度校验
    "dimTotal": "Total",//图表的对比维度：不拆维度
    "curPeriod": "Current",//图表图例：本期那条线
    "cycPeriod": "Compared",//图表图例：对比期那条线
    "legendDetail": "View details",//图表图例：展开 Top5 之外的类别
    "otherGroup": "Other",//图表图例：Top10 之外聚合出来的那条线
    "dimSortHint": "%s ranked by estimated revenue (high to low)",//图表维度下拉旁的说明：按预估收益由高到低的国家
    "vsCompare": "vs. compared",//较对比期
    "metricNamePattern": "%s (%p)",//卡片标题：预估收益（近7天）
    "exportFail": "Export failed"//导出失败
  },
  // 数据页面字段
  "statInfo": {
    "time": "Time",//时间
    "dimension": "Dimension",//维度
    "timeRange": "Date Range",//时间范围
    "to": "to",//至
    "startDate": "Start Date",//开始日期
    "endDate": "End Date",//结束日期
    "templateName": 'Template',//模板名称
    "trendChart": 'Trend Chart',//趋势图表
    "summaryReport": 'Summary Report',//汇总报表
    "close": "Collapse", //收起
    "open": "Expand", //展开
    "noData": "No Data", //暂无数据
    "date": "Date", //日期时间
    "rawReq": "Raw Request",//原始请求
    "bid": "Bid", //出价
    "exposure": "Impression", //曝光
    "exposureRate": "Impression Rate", //曝光率
    "click": "Click", //点击
    "clickRate": "CTR", //点击率
    "CPM": "CPM", //CPM
    "profit": "Revenue", //预估收益
    "export": "Export", //导出数据
    "os_type": "OS", //操作系统
    "application": "Application", //应用
    "media_ad_slot": "Ad Slot", //广告位
    "co_mode": "Co-op Mode", //合作模式
    "country": "Country", //国家
    "template_id": "Ad Type", //广告类型
    "table": "Statistics", //统计表格
    "downloadTip": "Data is for reference only. Actual settlement is based on reconciliation emails",//开发者后台数据仅供参考，实际结算以对账邮件为准
    "timezone": "Timezone", //时区
    "timeSummary": "Time Summary", //时间汇总
    "query": "Query", //查询
  },
  // 对账相关
  "reconciliation": {
    "placementMonth": "Month of placement",
    "templateName": "Template",
    "adZone": "Ad slot",
    "summaryReport": "Month Summary Report",
    "downloadTip": "Data is for reference only. Actual settlement is based on reconciliation emails",//开发者后台数据仅供参考，实际结算以对账邮件为准
    "generateReconciliation": "Generate statement",// 生成对账单
    "taxRate": "Tax Rate",//开票税率
    "monthsCheck": "Month Required",//投放月份不能为空
    "companyName": "Company Name",//公司主体全称
    "companyNamePlaceholder": "Please Enter Company Name",//请输入公司主体全称
    "companyNameCheck": "Company Name Required",//公司主体全称不能为空
    "batchDownloadBill": "Batch download of statements", //批量下载对账单
    "downloadBill": "Download of statements", //批量下载对账单
    "confirmDownloadBill": "Comfirm Download Reconciliation", //确认生成
    "rawReq": "Raw Request",//原始请求
    "bid": "Bid", //出价
    "exposure": "Impression", //曝光
    "exposureRate": "Impression Rate", //曝光率
    "click": "Click", //点击
    "clickRate": "CTR", //点击率
    "CPM": "CPM", //CPM
    "profit": "Revenue", //预估收益
  },
  // sdk相关
  "sdk": {
    "interaction": "Select Ad Interaction", //请选择广告交互
    "deviceId": "Device ID required", //请填写设备ID
    "adId": "Ad Slot ID required", //请填写广告位ID
    "flowType": "Ad Type", //广告类型
    "createNum": "Create quantity", //创建数量
    "adTemplate": "Ad Template", //广告模板
    "templateSize": "Template Size", //模板尺寸
    "styleConfig": "Style Configuration", //样式配置
    "rendeMode": "Rendering Mode",//渲染方式
    "platformRender": "Platform Render",//平台渲染
    "selfRender": "Self-render",//自渲染
    "styleSelection": "Style Selection",//样式选择
    "stylelprt": "Left Image Right Text",//左图右文
    "styleltrp": "Left Text Right Image",//左文右图
    "stylefb": "Text Above Image Below",//上文下图
    "styleab": "Image Above Text Below",//上图下文
    "elConfig": "Element Configuration",//元素配置
    "elImg": "Image",//图片
    "elCover": "Cover",//封面
    "elVideo": "Video",//视频
    "elTitle": "Title",//标题
    "elDesc": "Description",//描述
    "elIcon": "Icon", //icon
    "elProduct": "Brand",//品牌名称
    "elButton": "Button Text",//按钮文案
    "videoSound": "Audio", //视频声音
    "closeBtn": "Close Button", //关闭按钮
    "hidden": "Hide", //隐藏
    "display": "Show", //显示
    "soundOff": "Mute", //静音
    "soundRelease": "Unmute", //声音外放
    "videoAutoplay": "Autoplay", //视频自动播放
    "videoNoAuto": "No Autoplay", //不自动播放
    "webcast": "Auto-play with network", //有网络播放
    "wifiAuto": "WIFI Autoplay", //WIFI下自动播放
    "callback": "Callback Control", //回调控制
    "noServer": "No Server Check", //无需服务器判断
    "needServer": "Require Server Check", //需要服务器判断
    "callbackUrl": "Callback URL",//回调URL
    "secretKey": "Secret Key",//密钥
    "newSecretKey": "Generate New Key",//生成新密钥
    "adsenseShow": "Ad Slot Preview",//广告位展示
  },
  // 对接中心
  "docking": {
    "docApi": "API Integration",//api对接
    "docSdk": "SDK Integration",//sdk对接
    "docSdkWord": "SDK Documentation",//sdk接入文档
    "docSdkTest": "SDK Testing Tool",//sdk测试工具
    "docAppads": "App-ads.txt",//app-ads.txt指南
    "API": "API Documentation",//API接入文档
    "tipOne": "See detailed documentation at ",//详细文档请查看
    "tipTwo": ". Contact integration support for assistance.",//如需帮助，请联系相关对接人
    "tipThree": "Integration Guide",//接入指南
    "document": "Documentation",//文档
    "updateDate": "Updated",//更新日期
    "version": "Version",//版本号
    "domobAdx": "Domob ADX Integration Document (DomOB as the budget side)",//多盟ADX对接文档（多盟作为预算侧）
    "templateFile": "Template Files",//模板文件
    "proto": "Domob Proto Files",//多盟proto文件
    "domobSdkWord": "Domob SDK Guide",//多盟sdk对接文档 
    "AndroidWord": "Android Access Document",//安卓接入文档
    "IOSWord": "IOS Access Document",//IOS接入文档
    "mediaDataApi": "Media Data API",//媒体数据API接口 
    "domobSdk": "Domob SDK",//多盟sdk
    "updateLog": "Changelog", //更新日志
    "sdkTipOne": "Pre-integration testing tool for simulating real-world ad requests. See User Guide",//为sdk接入提供的接入前测试工具...
    "deviceName": "Device Name", //设备名称
    "deviceID": "Device ID", //设备ID
    "deviceIDP": "Enter IMEI/OAID/IDFA",//请输入imei/oaid/idfa设备号
    "deviceType": "Device Type", //设备类型
    "testStatus": "Test Status", //测试状态
    "addDevice": "Add Device", //新建设备信息
    "adInteraction": "Ad Interaction", //广告交互
    "testSaveTip": "Preview available 15 mins after configuration",//完成新建后预计15分钟后...
  },
  "message": {
    "errorComplete": "Complete all fields", //请输入完整的信息
    "successSava": "Saved", //保存成功
    "successLogin": "Login success", //登录成功
    "errorLogin": "Login failed", //登录失败
    "registLogin": "Registered", //注册成功
    "delete": "Deleted", //删除成功
    "add": "Add success", //添加成功
    "edit": "Edit success", //编辑成功
    "emailRegisted": "Email registered", //邮箱已经注册
    "telRegisted": "Phone registered", //手机号已经注册
    "completeCompanyInfo":"Your company information is incomplete. Please complete the required fields before continuing.",// 你的企业信息不完整，请先完善必填项再继续操作
    "cancel": "Cancel", //取消
    'confirmModify':"Confirm Modify",//确认修改
    'confirmCompanyInfo':"Comfirm companyInfo",//确认企业信息
    "completeForm":"Required field",//请完善表单必填项
    "mofifyPrompt":"Enterprise information is sensitive content and will take effect immediately after modification. Please confirm whether to proceed with the modification",//修改企业信息需要重新审核，是否继续？
    "listEmpty":"No download data available", //No download data available
    "confirmDelete": "Confirm delete this rule?", // 确认删除该条规则？
    "deleteMessage": "All bound applications and ad slots will be unbound", //所有绑定的应用和广告位将会被解绑
    "noData": "No Data", //暂无数据
  },
  // 请求失败的 toast（utils/ajax.js 的响应拦截器用）
  "http": {
    "netError": "Network error, please check your connection and try again",//没拿到响应
    "timeout": "Request timed out, please try again",//请求超时
    "failedWithCode": "Request failed (%s)",//拿到响应了，%s 是状态码
    "failed": "Request failed, please try again later",//连状态码都没有的兜底
  },
  "login": {
    "login": "Sign In", //登录
    "companyInfoLogin": "Continue to Dashboard", //登录
    "regist": "Sign Up", //注册
    "emailLogin": "Email Login", //邮箱登录
    "mobileLogin": "Mobile Login", //手机号登录
    "imgCode": "Captcha", //图形验证码
    "autoLogin": "Auto Login", //下次自动登录
    "welcomeLogin": "Welcome",//欢迎登录
    "welcomeSignup": "Welcome",//欢迎注册
    "companyInfo": "Company Information",//欢迎注册企业信息
    "companyInfoUse": "This information will help us set up your publisher account",//此信息将帮助我们为您设置发布者账户。
    "devPlatform": "Developer Platform",//开发者变现平台
    "logoDevPlatform": "Developer Monetization Platform",//logo旁开发者变现平台
    "forget": "Reset Password", //重置密码
    "register": "No account? Register", //没有账户？前往注册
    "toLogin": "Have account? Sign In", //已有账号？返回登录
    "cooperation": "Contact: pub-support@domob.cn", //合作联系：15811494601
    "abroadCooperation": "Contact: zhihang.cai@bluefocus.com", //合作联系：zhihang.cai@bluefocus.com
    "company": "Domob Technology", //多盟睿达科技(中国)有限公司
    "password": "Password", //请输入密码
    "email": "Email/Mobile", //邮箱/手机号
    "nameCheck": "Username required", //用户名不能为空
    "pwdCheck": "Password required", //密码不能为空
    "confirmPwdCheck": "Password again required", //请再次确认密码
    "min": "Min 6 characters", //最少为6个字符
    "codeCheck": "Captcha required", //图片验证码不能为空
    "codeCheckFalse": "Invalid captcha", //验证码输入有误
    "submit": "Submit",//提交
    "setPwd": "Set password (at least 6 characters)",//设置密码(不能少于6个字符)
    "confirmPwd": "Confirm Password",//请确认密码
    "pwdNotMatch": "Entered passwords differ!", //两次输入的密码不一致
    "enterprise": "Enterprise",//企业账号
    "personal": "Individual",//个人账号
    "phoneError": "Invalid phone", //手机号输入有误
    "emailCheck": "Enter email", //请输入邮箱
    "emailError": "Invalid email", //邮箱格式异常
    "pwdAgain": "Confirm password", //请再次输入密码
    "pwdDiff": "Password mismatch", //两次输入密码不一致
    "loginIng": "Logging in", //登录中
    "msg1": "SMS verification code sent",//短信验证码已发送至您手机...
    "msg2": "Complete email verification to login",//为了保证您的账号安全...
    "msg3": "Resend",//发送邮件
    "msg4": "Email verified!",//邮箱验证成功！
    "msg5": "Verification failed!",//邮箱验证失败！
    "msg6": "Invalid link:",//链接已经无效...
    "msg7": "Link expired;",//链接已经过期；
    "msg8": "Link already used;",//链接有可能已经使用过；
    "msg9": "Email changed",//您修改了帐户的邮箱
    "msg10": "The email verification code has been sent to your email, please check it!",//邮箱验证码已发送至您邮箱，请注意查收！
  },
  "forget": {
    "title": "Domob Developer", //多盟开发者后台
    "type": "Recovery Method", //找回密码方式
    "valid": "Verification", //账号验证
    "resetPwd": "Reset Password", //重设密码
    "phone": "Mobile Recovery", //手机找回
    "email": "Email Recovery", //邮箱找回
    "tel": "Mobile", //手机号
    "Email": "Email", //邮箱
    "msgCode": "SMS Code", //短信验证码
    "emailCode": "Email Code", //邮箱验证码
    "toEmail": "Use Email", //使用邮箱找回
    "toPhone": "Use Mobile", //使用手机找回
    "showEinfoMsg": "Verification email sent", //我们刚给你发了一封电子邮件...
    "next": "Next", //下一步
    "getCode": "Get Code", //获取验证码
    "sendEmail": "Send Email", //发送验证邮箱
    "getEmail": "Get Email", //获取验证邮箱
    "codeError": "Invalid code", //验证码输入有误
    "phoneCheck": "Mobile required", //手机号不能为空
    "smsCheck": "SMS code required", //短信验证码不能为空
    "verifyCheck": "Code required", //验证码不能为空
    "newPwd": "New password", //请输入新密码
    "renewPwd": "Confirm password", //请再次输入新密码
    "confirm": "Confirm", //确认修改
    "resetSuccess": "Password reset", //密码重置成功
    "congratulate": "Password updated", //恭喜您，已经成功设置新的密码
    "loginNow": "Login now", //立即登录
    "resetError": "Reset failed!", //密码重置失败！
    "beover": "Invalid/expired link", //链接已经无效...
    "resetPass": "Retry reset", //再次申请重置密码
    "reInputPsd": "Password mismatch", //密码不一致...
    // 忘记密码
    "entry": "Forgot password?", //登录页入口文字链
    "pageTitle": "Reset Password", //页面标题
    "pageDesc": "Enter the email or mobile number you registered with, we'll check the account first", //页面说明
    "stepVerify": "Verify Identity", //步骤1
    "stepNewPwd": "Set New Password", //步骤2
    "stepDone": "Done", //步骤3
    "verifyByEmail": "Email", //邮箱验证
    "verifyByPhone": "Mobile", //手机号验证
    "telPlaceholder": "Enter your registered mobile number", //找回密码页手机号输入框占位文案
    "emailFormat": "Invalid email format", //邮箱格式不正确
    "phoneRequired": "Please enter your mobile number", //请输入手机号
    "phoneFormat": "Invalid mobile number format", //手机号格式不正确
    "notRegisteredEmail": "This email is not registered. Please check and try again, or", //该邮箱未注册...
    "notRegisteredPhone": "This mobile number is not registered. Please check and try again, or", //该手机号未注册...
    "goSignup": "sign up", //前往注册
    "backToLogin": "Back to login", //返回登录
    "prevStep": "Previous", //上一步
    "resetTitle": "Reset Password", //重置密码
    "captchaWrong": "Please enter the correct image code", //请填写正确的图形验证码
    "confirmPwdPh": "Re-enter password (at least 6 characters)", //再次输入密码...
    "resetDoneDesc": "For your security, this account has been signed out on all other devices.Please sign in again with your new password.", //重置成功说明，\n 处强制断行
    "autoRedirect": "(Redirecting in %ss)", //（%s 秒后自动跳转）
    "resend": "Resend", //重新获取
    "resendPattern": "Resend in %ss", //重新获取 XXs
  },
  "companyInfo": {
    "companyName": "Company Name", //企业法定名称
    "brandNameEN": "Brand Name(EN)", //企业英文简称
    "brandNameCN": "Brand Name(CN)", //企业中文简称
    "country": "Country/Region", // 国家/地区
    "industry": "Industry", //行业分类
    "websiteURL": "Website URL", //官网
    "companyNameCheck": "Company Name required", //企业法定名称不能为空
    "companyNameStartEndCheck": "Company name cannot start or end with numbers",
    "companyNameCNCharCheck": "Company name cannot contain invalid characters",
    "companyNameLengthCheck": "Company name length must be 2-120 characters",
    "companyNameSpecialCharCheck": "Company name does not allow special characters or emojis",
    "companyNameFormatCheck": "Company name only allows Chinese, English letters and spaces",
    "brandNameENCheck": "Brand Name(EN) required", // 企业英文简称
    "countryCheck": "Country/Region required", //国家/地区不能为空
    "industryCheck": "Industry required", //行业分类不能为空
    "companyNameFormatCheck": 'Only Chinese or English characters allowed, no special characters',//只能输入中文或英文，不可包含特殊字符
    "brandNameENFormatCheck": 'Only English characters',//只能包含英文字符
    "brandNameENUniqueCheck": 'Must not be identical to Company Name',//不能与企业名称完全一致
    "brandNameCNFormatCheck": 'No special characters allowed',//不可包含特殊字符
    "brandNameCNChineseCheck": 'Must contain Chinese characters',//必须包含中文字符
    "websiteFormatCheck": 'Please enter a valid URL format URL',//请输入正确的 URL 格式
    "companyInfo": "Tell us about your company", //企业信息
    "companyInfoTitle": "This information will help us set up your publisher account", //这可以帮助我们创建你的开发者账户
    "companyNamePlaceholder": "Enter your registered company name", //请填入注册的公司名称
    "prompt": "Must match your official registration name", // 必须和你注册的企业名称匹配
    "urlExplame": "https://example.com",//websiteURL的例子
    "edit": "Edit", //编辑
    "cancel": "Cancel", //取消
    "reset": "Reset", //重置
    "save": "Save", //保存
  },
  "block": {
    "blockContent": "Blocked Content", //屏蔽内容
    "effectScope": "Apply to", //生效范围
    "ruleName": "Rule Name", //规则名称
    "blockApp": "Blocked Apps", //屏蔽应用
    "blockDomain": "Blocked Domains", //屏蔽域名
    "blockCategory": "Blocked Categories", //屏蔽类别
    "blockKeyword": "Blocked Keywords",//屏蔽关键词
    "effectScope": "Apply to", //生效范围
    "app": "Apps", //应用
    "domain": "Domains", //域名
    "category": "Categories", //类别
    "keyword": "Keywords",//关键词
  },
  "dialog": {
    "addRule": "Create", //新建屏蔽规则
    "editRule": "Edit", //编辑屏蔽规则
    "enterApp": "Please enter the package names, separated by line breaks.",//请输入包名，包名之间以换行符分隔
    "enterDomain": "Please enter the domain names, separated by line breaks.", //请输入域名，域名之间以换行符分隔
    "enterCategory": "Please select category", //请选择类别
    "enterKeyword": "Enter keyword,keywords separated by line breaks", //请输入关键词，关键词之间以换行符分隔
    "enterRuleName": "Please enter rule name",//请输入搜索规则
    "selectEffectScope": "Please select apply to", //请选择生效范围
    "appInvaildMessage": "invalid app ignored", //个无效的应用已忽略
    "appRepeatMessage": "repeated app ignored", //个重复的应用已忽略
    "domainInvaildMessage": "invalid domains ignored", //个无效的域名已忽略
    "domainRepeatMessage": "repeated domains ignored", //个重复的域名已忽略
    "confirmLeave": "Confirm Leave", //确定离开
    "message": "If you leave, the content you filled in will not be saved. Please keep it.", //如果离开，您填写的内容将不会被保存
    "yes": "YES", //是
    "no": "NO", //否
  },
  // 子账号管理
  "subAccount": {
    "tabRole": "Roles",
    "tabAccount": "Accounts",
    "menu": {
      "sdkDoc": "SDK Integration Doc",
      "sdkTest": "SDK Test Tool",
      "appAdsTxt": "App-Ads.txt",
      "settleView": "Settlement (view only)",
      "settleOperate": "Settlement (full access)",
      "bankInfo": "Bank Info",
      "subAccount": "Sub-account",
    },
    "picker": {
      "selectedCount": "{n} selected",
      "clearAll": "Clear all",
      "selectAll": "Select all",
      "searchMenu": "Search menu…",
      "searchApp": "Search app name / package",
      "noMenuSelected": "No menu granted",
      "noAppSelected": "No app selected",
      "noMatch": "No match",
    },
    "role": {
      "name": "Role",
      "namePh": "Please enter role name",
      "roleName": "Role Name",
      "nameFieldPh": "Please enter role name",
      "menuPerm": "Menu access",
      "appPerm": "App access",
      "accountCount": "Accounts",
      "createdAt": "Created At",
      "updatedAt": "Updated At",
      "create": "Create Role",
      "edit": "Edit Role",
      "allApps": "All apps",
      "allMenus": "All menus",
      "someApps": "Selected apps",
      "someAppsCount": "{n} app(s)",
      "more": "+{n} more",
      "menuPermCount": "Menu access ({n})",
      "appPermCount": "Authorized apps ({n})",
      "selectAppPerm": "Please select app access",
      "created": "Role created",
      "saved": "Role saved",
      "deleted": "Role deleted",
      "deleteTitle": "Delete role?",
      "deleteBody": "Role {name} will be deleted. It has no accounts, so no login is affected",
      "deleteBlocked": "This role still has {n} account(s). Move them to another role or delete them first",
      "jumpedToAccounts": "Switched to Accounts, filtered by role \"{name}\"",
      "confirmDelete": "Delete",
      "errNameEmpty": "Please enter role name",
      "errNameLength": "Role name must not exceed 20 characters",
      "errNameExists": "Role name already exists",
      "errAppEmpty": "Please select at least one app for \"Selected apps\"",
      "errMenuEmpty": "Please grant at least one menu",
    },
    "account": {
      "email": "Login Email",
      "name": "Account Name",
      "role": "Role",
      "keyword": "Email / Account name",
      "keywordPh": "Please enter keyword",
      "rolePh": "Please select role",
      "statusPh": "Please select status",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "add": "Add Account",
      "edit": "Edit Account",
      "mainTag": "Owner",
      "allPerm": "Full access",
      "namePh": "Please enter account name",
      "emailPh": "Please enter login email",
      "rolePh": "Please select the role of this account",
      "createTitle": "Create this account?",
      "createBody1": "The initial password will be sent to {email}. Please make sure the address is correct.",
      "createBody2": "The email contains the login URL, the login email and a system-generated initial password, and tells the recipient they can reset it via \"Forgot password\" on the login page.",
      "createConfirm": "Create",
      "created": "Account created, initial password sent to {email}",
      "saved": "Saved",
      "statusOn": "Account {email} enabled",
      "statusOff": "Account {email} disabled and can no longer log in",
      "deleteTitle": "Delete account?",
      "deleteBody": "Account {name} ({email}) will be deleted and can no longer log in.",
      "deleted": "Account deleted",
      "errEmailEmpty": "Please enter login email",
      "errEmailFormat": "Invalid email format",
      "errEmailExists": "This email is already in use",
      "errNameEmpty": "Please enter account name",
      "errRoleEmpty": "Please select the role of this account",
    },
  },
  "save": "Save", // 保存
  "confirm": "Confirm", //确认
  "cancel": "Cancel", // 取消
  "logout": "Logout",//退出登录
  ...enLocale
}